import { dialog } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'dialog',
  label: 'Dialog',
  category: 'Feedback',
  image: dialog
};
